import { makeNumberRenderer } from 'App/data-export/valueTypeRenderers/renderers/_utils/makeNumberRenderer'
import type { valueTypeRenderers } from 'App/data-export/valueTypeRenderers/valueTypeRenderers'
import { unitConverter } from 'utils/unitConverter/unitConverter'

export const signalTS5: typeof valueTypeRenderers.signalTS5 = {
  label: () => unitConverter.plantWaterStress().titleWithoutUnit(),
  point: () =>
    makeNumberRenderer({
      baseLabel: unitConverter.plantWaterStress().title(),
      render: (n) => unitConverter.plantWaterStress(n).valueAsString(),
    }),
}
